module.exports = __webpack_public_path__ + "static/img/btc_btn_en.6ef26f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btc_btn_en.png
// module id = RMKB
// module chunks = 51